export const getInviteDeliveryFailureMessage = (error) => {
  const firstFailure = error?.response?.data?.results?.failed?.[0]?.error;
  if (typeof firstFailure !== 'string' || !firstFailure.trim()) {
    return null;
  }

  return `Invites could not be sent (${firstFailure.trim()}). You can still share the invite link.`;
};

// Friendly wording for the backend's joinabilityReason codes ('season_started',
// 'league_full', 'quickplay', 'league_missing'). The codes are the contract;
// backend error text may drift, so it is never shown for these.
const INVITEE_JOINABILITY_MESSAGES = {
  season_started: "This league's season has already started, so new teams can't join right now. Ask the league owner to invite you for the next season.",
  league_full: 'This league is full. If a spot opens up, this link will work again.'
};

const OWNER_JOINABILITY_MESSAGES = {
  season_started: "Your league's season has already started, so new members can't join right now.",
  league_full: "Your league is full, so new members can't join right now."
};

const INVITEE_JOINABILITY_FALLBACK = "This invitation can't be used right now.";
const OWNER_JOINABILITY_FALLBACK = "New members can't join this league right now.";

const pickJoinabilityMessage = (messages, reason, fallback) => (
  typeof messages[reason] === 'string' ? messages[reason] : fallback
);

export const getInviteeJoinabilityMessage = (reason) => (
  pickJoinabilityMessage(INVITEE_JOINABILITY_MESSAGES, reason, INVITEE_JOINABILITY_FALLBACK)
);

export const getOwnerJoinabilityMessage = (reason) => (
  pickJoinabilityMessage(OWNER_JOINABILITY_MESSAGES, reason, OWNER_JOINABILITY_FALLBACK)
);

// Owner-side mutation errors: only a 409 that carries a joinabilityReason is
// translated; anything else returns null so call sites keep their existing
// handling.
export const getOwnerJoinabilityErrorMessage = (error) => {
  if (error?.response?.status !== 409) {
    return null;
  }
  const reason = error?.response?.data?.joinabilityReason;
  if (!reason) {
    return null;
  }
  return getOwnerJoinabilityMessage(reason);
};
